<template>
  <div class="location">
    <van-nav-bar title="选择城市" left-arrow @click-left="goback()" />

    <div class="location_select">
      <div class="color999 fs15">定位城市</div>
      <div class="select_item">
        <div class="item">
          <van-icon class="m-r10" name="map-marked" color="#FF9800" size="18" />
          {{ locationValue }}
        </div>
        <div class="item_replay" @click="getCurrentLocation()">
          <van-icon name="replay" color="#999" />
          重新定位
        </div>
      </div>
    </div>

    <van-index-bar>
      <van-index-anchor
        v-for="(item, index) in infoList"
        :key="index"
        :index="index"
      >
        {{ index }}
        <van-cell
          @click="changeLocationValue(items.name, items.whole_name)"
          :title="items.name"
          v-for="(items, indexs) in item"
          :key="indexs"
        />
      </van-index-anchor>
    </van-index-bar>
  </div>
</template>
<script>
import { NavBar, IndexBar, Cell, IndexAnchor, Icon } from "vant";
import cityData from "@/assets/js/city.js";
import common from "@/utils/common";
import storage from "@/utils/storage";

export default {
  components: {
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Cell.name]: Cell,
  },

  data: function () {
    return {
      locationValue: "中山市",
      infoList: {
        A: [],
        B: [],
        C: [],
        D: [],
        E: [],
        F: [],
        G: [],
        H: [],
        I: [],
        J: [],
        K: [],
        L: [],
        M: [],
        N: [],
        O: [],
        P: [],
        Q: [],
        R: [],
        S: [],
        T: [],
        U: [],
        V: [],
        W: [],
        X: [],
        Y: [],
        Z: [],
      },
    };
  },

  //初始化加载
  created() {
    var cityInfo = []; //城市名称
    cityData.data.forEach((element) => {
      if (element.hasOwnProperty("children")) {
        cityInfo.push(element.children);
      }
    });

    for (var key in this.infoList) {
      cityInfo.forEach((item) => {
        item.forEach((itemChild) => {
          if (key === itemChild.per_pin_yin) {
            this.infoList[key].push({
              name: itemChild.name,
              whole_name: itemChild.whole_name.split("，")[1],
            });
          }
        });
      });
    }

    //如果有缓存地址则直接赋值当前地址
    var address = storage.getCurrentLocation();
    if (address) {
      this.locationValue = address.selectAddress;
    } else {
      //获取当前定位地址
      this.getCurrentLocation();
    }
  },

  methods: {
    //获取当前定位地址
    getCurrentLocation() {
      var that = this;
      //定义回调函数
      window.initBaiduMapScript = () => {
        that.BMap = window.BMap;
        var geolocation = new that.BMap.Geolocation();
        geolocation.getCurrentPosition(
          function (r) {
            if (this.getStatus() == 0) {
              r.selectAddress = r.address.city;
              //成功获取位置信息
              that.locationValue = r.address.city;
              //设置当前地址信息
              storage.setCurrentLocation(r);
            } else {
              //无法获取到位置信息
              that.locationValue = "无法获取定位信息，请重新定位!";
            }
          },
          {
            enableHighAccuracy: true,
          }
        );
      };
      //调用脚本获取位置信息
      common.loadBMap("initBaiduMapScript");
    },

    //改变当前位置值
    changeLocationValue(value, whole_name) {
      this.locationValue = value;
      window.scrollTo(0, 0);
      //改变当前地址信息并存入缓存中
      var currentLocation = storage.getCurrentLocation();
      currentLocation.address.province = whole_name;
      currentLocation.address.city = value;
      currentLocation.selectAddress = value;
      storage.setCurrentLocation(currentLocation);
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="less" >
.location {
  .location_select {
    display: flex;
    flex-direction: column;
    padding: 30px 10px;
    border-bottom: 1px solid #e9e9e9;

    .select_item {
      display: flex;
      flex-direction: row;
      font-size: 14px;
      margin-top: 15px;
      align-items: center;

      .item {
        border-radius: 5px;
        background: #f4f4f4;
        padding: 5px 15px;
      }

      .item_replay {
        margin-left: 25px;
      }
    }
  }

  .van-index-bar__index {
    color: #ff9800;
  }

  .van-cell {
    padding: 0.26667rem 0rem;
  }
  .van-cell::after {
    left: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/home/location.vue